import React, { useCallback, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import { has as _has, isEmpty as _isEmpty } from 'lodash';
import { useMobxStores } from '@stores/store';
import queryString from 'query-string';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainStoreBtn from '@atoms/btn/MainStoreBtn';
import MobileUniverse from '@organisms/main/mobile/partial/MobileUniverse';
import { useWindowSize } from 'usehooks-ts';
import PartialNoticeBox from '@organisms/main/partial/PartialNoticeBox';

const SectionTopContents = () => {
  const { i18n, t } = useTranslation();
  const { communityStore, devlogStore, mainStore } = useMobxStores();
  const navigate = useNavigate();
  const location = useLocation();
  let query = queryString.parse(location.search);
  const [onActiveIndex, setOnActiveIndex] = useState(0);

  const { width } = useWindowSize();
  let sectionStyle = {};
  if (width > 640) {
    sectionStyle = {
      backgroundImage: 'url(/img/v2/main/bg/bg_pc_notice.png)',
      backgroundSize: '100%',
      backgroundPosition: 'top',
      backgroundRepeat: 'no-repeat',
    };
  } else {
    sectionStyle = {
      backgroundImage: 'url(/img/v2/main/mobile/bg/bg_m_notice.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'bottom ',
      backgroundRepeat: 'no-repeat',
    };
  }

  const getInitialData = useCallback(async () => {
    communityStore.setListQuery('noticeList', {
      lang: i18n.language,
      size: 3,
      page: 1,
    });
    await communityStore.getNoticeList();

    communityStore.setListQuery('eventList', {
      lang: i18n.language,
      size: 3,
      page: 1,
    });
    await communityStore.getEventList();

    return true;
  }, [communityStore, i18n.language]);

  useEffect(() => {
    getInitialData();
  }, [communityStore, getInitialData]);

  return (
    <>
      <section style={sectionStyle}>
        <div className="px-[15px] xs:px-[30px]">
          <div className="sm:pt-[15px] w-full  text-center ">
            <MainStoreBtn />
          </div>

          <div className="pt-[45px] xs:pt-[90px] relative">
            <div className="w-full pl-3 font-bold xs:text-3xl text-xl mb-2 white-shadows ">
              {t('공지사항')}
            </div>
            <img
              src="/img/v2/main/mobile/notice_01.png"
              className="absolute top-[-20px] right-[-15px] xs:right-[-30px]  w-[50%] sm:hidden"
            />
            <PartialNoticeBox
              data={communityStore.noticeList.contents}
              type={'news'}
            />
          </div>

          <div className="pt-[25px] xs:pt-[90px] mb-[100px] xs:mb-[300px] ">
            <div className="w-full pl-3 font-bold xs:text-3xl text-xl mb-2 white-shadows ">
              {t('이벤트')}
            </div>
            <PartialNoticeBox
              data={communityStore.eventList.contents}
              type={'event'}
            />
          </div>
          <MobileUniverse />
        </div>

        <div className="relative">
          <img
            src="/img/v2/main/universe_char.png"
            alt=""
            className="w-full mt-[-49px]"
          />
        </div>
      </section>
    </>
  );
};

export default observer(SectionTopContents);
